<template lang="pug">
  .v-phone-input(:class="{'is-danger': (!isValidInp && phone) }")
    vue-tel-input(
      :value="phone"
      @onInput="onInput"
      :placeholder.sync="placeholder"
      ref="phoneInput"
      @country-changed="updatePlaceholder"
      @validate="validate"
      @onBlur="$emit('blur')"
    )
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import { gettext } from '@/services/TranslateHandler'
import VueTelInput from 'vue-tel-input'
import PhoneNumber from 'awesome-phonenumber'

Vue.use(VueTelInput)

export default {
  name: 'VPhoneInput',
  data () {
    return {
      isValidInp: false,
      updated: false,
      placeholder: '',
      isMounted: false
    }
  },
  props: {
    phone: {
      default: ''
    },
    disabled: {
      default: false
    }
  },
  methods: {
    gettext: gettext,
    onInput ({ number, isValid, country }) {
      this.isValidInp = isValid
      this.$emit('input', { number: number.international, isValid, country })
      this.$emit('onInput', { number: number.international, isValid, country })
    },
    updatePlaceholder () {
      let dial = this.$refs.phoneInput.activeCountry.dialCode
      let example = PhoneNumber.getExample(this.$refs.phoneInput.activeCountry.iso2, 'mobile').getNumber('international').replace(/[0-9]/g, 'X')
      this.placeholder = this.replaceAt(example, 1, dial)
    },
    replaceAt (string, index, replace) {
      return string.substring(0, index) + replace + string.substring(index + replace.length)
    },
    validate (val) {
      this.isValidInp = val.isValid
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ])
  },
  watch: {
    getLanguage: function () {
      this.placeholder = this.gettext('Enter a phone number')
    },
    phone: function () {
      this.updated = true
    },
    isValidInp: function (val) {
      this.$emit('valid', val)
    }
  },
  created () {
    this.placeholder = this.gettext('Enter a phone number')
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style lang='scss'>
  .v-phone-input {
    position: relative;
    border: 1px solid transparent;
    background: #fff;
    width: 100%;
    .dropdown-item{
      padding: 4px 7px!important;
    }
    &.is-danger{
      border: 1px solid red;
    }
    .vue-tel-input{
      border: none!important;
    }
    .dropdown{
      width: 100% !important;
      position: absolute !important;
      top: 0;
      left: 0;
      z-index: 11;
      &:before, &:after{
        display: none;
      }
      .dropdown-arrow{
        display: none;
      }
      .selection .iti-flag {
      }
      ul{
        top: 50px;
        z-index: 2;
        width: 100%;
        box-sizing: content-box;
      }
    }
    input {
      z-index: 11;
      width: 100%;
      margin-left: 50px;
      &::placeholder{
        color: rgba(65, 64, 66, .3)!important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/v-phone-input/index.vue